import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import LocationIcon from "../../../public/images/icons/Vector.png";
import CloseIcon from '@mui/icons-material/Close';
import Image from "next/image";
import { useAppContext } from '../../../AppContext';
import { useTheme } from '@mui/material/styles';

function Title({data, totalNoOfTickets, onClose,emptyBeforeClose }) {  
    const theme = useTheme();
    const { url, themeData, siteData,  themeLoading, siteLoading, themeError, siteError, changeUrl, updateThemeData, updateSiteData } = useAppContext();
    const [themeCss, setThemeCss] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(()=>{
      let custom_css = themeData && themeData ? JSON.parse(themeData && themeData.custom_css): null;
      setThemeCss(custom_css)
      setLoading(false)
    }, [themeData]);

    const closeIconStyle = {
        fontSize: 18,
        color: theme.palette.primary.contrastText,
        mx:0,
        cursor:'pointer'
    }

    const ticketTitleCard = {
        background: theme.palette.background.alternate,
        position: '-webkit-sticky',
        position: 'sticky',
        top: '0px',
        pl: theme.spacing(4),
        pr: theme.spacing(1),
        py: theme.spacing(2),
        zIndex: 999,
        boxSadow: theme.shadows[3],
        // borderBottom: `1px solid ${theme.palette.background.borderColor}`,
        [theme.breakpoints.down("md")]: {
            px: theme.spacing(2),
            pl: theme.spacing(2),
            pr: theme.spacing(1),
        },    
        '& h4': {
            fontFamily: themeCss && themeCss.theme_primary_font ? (themeCss.theme_primary_font).replace("+"," ") : '',
            fontSize: 20,
            color: theme.palette.primary.contrastText,
            fontWeight: 400,
            textTransform: 'capitalize !important',
            marginBottom: theme.spacing(1),
            [theme.breakpoints.down("md")]: {
                fontSize: 18, 
                marginBottom: theme.spacing(0),  
            },
        },
        '& h5': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 14,
            color: theme.palette.primary.contrastText,
            fontWeight: 400,
            textTransform: 'capitalize !important',
            [theme.breakpoints.down("md")]: {
              marginBottom: theme.spacing(0),  
          },
        },
        '& h6': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 12,
            color: theme.palette.primary.location,
            textTransform: 'capitalize !important',
        },
    };
  return (
      <>            
        <Typography component="div" sx={ticketTitleCard}>
              <Stack
                  display="flex"
                  justifyContent="space-between"
                  flexDirection="row"
              >
                    <Typography component="div">  
                        <Typography variant="h4">{data.title.toLowerCase()}</Typography>
                        {/* <Typography variant="h6">{data.event_type ? data.event_type : ""}</Typography> */}
                        <Typography variant="h6">
                        <>
                            <Image
                            src={LocationIcon}
                            alt=""
                            width={10}
                            height={13}
                            // layout="fixed"
                            />
                            &nbsp;&nbsp;
                            {data.event_venue ? data.event_venue : (
                                <>
                                {data.clubName ? data.clubName+", " : ""}, 
                                {data.area_name ? data.area_name+ ", " : ""} 
                                {data.cityName} 
                                </>
                            )}                                                      
                        </>
                        </Typography>
                        <Typography variant="h5" sx={{mt:1}}>                        
                        {data.only_today != "0000-00-00" ? (
                            <span>
                            {moment(data.only_today).format("ddd DD MMM")}  | {data.start_time.slice(0, 5)} Hrs Onwards                    
                            </span>
                        ) : (
                            <span>
                            {moment(data.from_date).format("ddd DD MMM")} -{" "}
                            {moment(data.to_date).format("ddd, DD MMM")} | {data.start_time.slice(0, 5)} Hrs Onwards 
                            </span>
                        )}
                        </Typography>                        
                    </Typography>
                    <Typography component="div" sx={{mr:-1}}>
                        {totalNoOfTickets > 0 ? (
                            <Button onClick={emptyBeforeClose} style={{ color: `${themeCss && themeCss.theme_main_color} !important`, cursor: "pointer" }}>
                                <CloseIcon sx={closeIconStyle} />
                            </Button>
                        ) : (
                            <Button onClick={onClose} style={{ color: `${themeCss && themeCss.theme_main_color} !important`, cursor: "pointer" }}>
                                <CloseIcon sx={closeIconStyle} />
                            </Button>
                        )}
                    </Typography>
            </Stack>
        </Typography>                          
    </>
  );
}

export default Title;

